import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: any;
  setupForm: any;
  ClearDbForm: any;
  tempOptionModel: any;
  programs: any = [];
  errorMessage: Boolean = true;
  submitted = false;
  passwordSubmitted = false;
  hideClearDB: boolean = true;
  clearDBsubmit = false;

  userType: any = '';
  smloginForm: any;
  otpForm: any;
  emailotpForm:any;
  userData: any;

  inputPasswordType: string = "password"
  roles: any = [];
  emailData: any;
  role_id: any ='';

  //domain change
  loginMode: 'bigcity' | 'jeeto' = 'bigcity';
  hostName: string = '';



  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService,
    public modalService: NgbModal,
    public location: Location,

  ) {
    this.checkLogin();

    this.loginForm = formBuilder.group({
      // username: ['', Validators.compose([Validators.required])],
      email_id: ['', Validators.compose([Validators.required, Validators.pattern(
  /^([a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}|[a-zA-Z]+\.[a-zA-Z]+@pernod-ricard\.com)$/i
)])],
      role_id: ['',Validators.compose([Validators.required])],
      // password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      program_id: ['', Validators.compose([Validators.required,])],
    });
    this.setupForm = formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6),
      ])],
    });

    this.ClearDbForm = formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      program_id: ['', Validators.compose([Validators.required])],
    });

    this.smloginForm = formBuilder.group({
      // mobile_no: ['', Validators.compose([
      //   Validators.required,
      //   Validators.pattern("^[0-9]*$"),
      //   Validators.minLength(10),
      //   Validators.maxLength(10)
      // ])
      email_id: ['', Validators.compose([Validators.required, Validators.pattern(
  /^([a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}|[a-zA-Z]+\.[a-zA-Z]+@pernod-ricard\.com)$/i
)])],

      
    });

     this.otpForm = formBuilder.group({
      otp: ['', Validators.compose([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(6),
        Validators.maxLength(6)
      ])],
      
    });
     this.emailotpForm = formBuilder.group({
      otp: ['', Validators.compose([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(6),
        Validators.maxLength(6)
      ])],
      
    });

    this.loginForm.valueChanges
      .subscribe(data => {
      });


  }
  get c() { return this.loginForm.controls; }
  get p() { return this.setupForm.controls; }
  get db() { return this.ClearDbForm.controls; }
  get f() { return this.smloginForm.controls; }
  get v() { return this.otpForm.controls; }
  get k() { return this.emailotpForm.controls; }

  ngOnInit() {

    //domian change
    this.hostName = window.location.hostname || '';

  if (this.hostName.includes('clientweb.bigcityvoucher.co.in') || this.hostName.includes('console.jeetorewards.in')) {
    this.loginMode = 'jeeto';
    this.userType = 2;
  } else if (this.hostName.includes('hubadmin.bigcityvoucher.co.in')|| this.hostName.includes('hubadminweb.jeetorewards.in')) {
    this.loginMode = 'bigcity';
    this.userType = 1;
  }
  else if (this.hostName.includes('localhost') ){
      this.userType = 'developer'
  }
   else {
    // fallback, if some other domain is used
    this.loginMode = 'bigcity';
    this.userType = 1;
  }

  // if (this.hostName.includes('clientweb')) {
  //   this.loginMode = 'jeeto';
  //   this.userType = 2;
  // } else if (this.hostName.includes('localhost:')) {
  //   this.loginMode = 'bigcity';
  //   this.userType = 1;
  // }
  //  else {
  //   // fallback, if some other domain is used
  //   this.loginMode = 'bigcity';
  //   this.userType = 1;
  // }

  this.getPrograms();
  this.getListRoles();
    // this.emailData = []
  }

  getListRoles(){
    this.apiService.get(this.apiConfig.listroles)
    .subscribe((res:any)=>{
      console.log(res,'roles')
      this.roles = res.data
    })
  }

  sendEmailOtp(payload){
    console.log(payload,'payload')
    payload.role_id = Number(payload.role_id)
    this.role_id = Number(payload.role_id)
    window.localStorage.setItem('program', JSON.stringify({ program_id: 1 }));
    this.apiService.post(this.apiConfig.sendEmailOtp,payload)
    .subscribe((res:any)=>{
      console.log(res,'sendotp')
      this.emailData = res.body.data
    })
  }

  verifyEmailOtp(payload){
    console.log(payload,'payload')
    payload.role_id = this.role_id
    payload.email_id = this.emailData.email
    this.apiService.post(this.apiConfig.verifyEmail, payload)
    .subscribe((res:any)=>{
      console.log(res,'verifyEmailotp')
       if (res.status == 200) {
          // this.errorMessage = true;
          console.log(res,'res')
          let body = res.body;
          this.toast.Success('Login successful');
          localStorage.setItem("user_name", (res.body.data.user_name));
          localStorage.setItem("user_id", (res.body.data.id));
          window.localStorage.setItem("program", JSON.stringify(res.body.data));
          this.auth.saveAuth(body.data.access_token);
          this.submitted = false;
          if (body.data.user_role == 1 || body.data.role_name == 'Organization' || body.data.profile_code == 'GNRL') {
            this.router.navigate(["/hubAdmin/dashboard"]);
            this.callProgramConfigApi();
          }
          else if (body.data.role_name == 'Staff') {
            this.router.navigate(["teamleader"]);
          }
          else if (body.data.role_name == 'Agent') {
            this.router.navigate(["agent"]);
          } else if (body.data.role_name == 'Redemption') {
            this.router.navigate(["redemption"]);
          } else if (body.data.role_name == 'Reporting') {
            this.router.navigate(["reports"]);
          } else if (body.data.user_role == 9) {
            localStorage.setItem('reward_role',body.data.user_role)
            this.router.navigate(['/operationalhead/sucess-order-list']);
            // this.router.navigate(['operationalhead']);
          } else if (body.data.user_role == 10) {
            localStorage.setItem('reward_role',body.data.user_role)
            this.router.navigate(['/operationalhead/failed-order-loss']);
            // this.router.navigate(['operationalhead']);
          }
           else if (body.data.user_role == 11) {
            // console.log(body.data.role_name,'role_name');
            this.router.navigate(["concierge"]);
          }
           else if (body.data.role_name == 'Finance') {
           this.router.navigate(["finance"]);
          } else if (body.data.role_name == 'Authorization') {
             this.router.navigate(["authorization"]);
          }
          else {
            this.toast.Success('You dont have access to this module');
          }
        }
    }, err=>{

    })
  }


  checkLogin() {
    // debugger
    let previousURL = localStorage.getItem("previousURL")
    let login = localStorage.getItem("login")
    if (login == 'true') {
      this.router.navigateByUrl(previousURL)
    }

  }

  mailOtp(){
    console.log('mailOtp')
  }

  getPrograms() {
    this.apiService.get(this.apiConfig.get_all_the_programs)
      .subscribe((res: any) => {
        console.log(res)
        this.programs = res.data;
        // localStorage.setItem('progrm',this.programs)
        // this.programs = [];
      }, err => {

      })
  }

  projectSetup(formData) {
    this.passwordSubmitted = true;
    // 
    if (this.setupForm.invalid) {
      return
    }

    this.apiService.get(this.apiConfig.setupProgram + formData.password)
      .subscribe((res: any) => {
        this.toast.Success('Project setup successfully completed')
        this.getPrograms()
      }, err => {
        // this.toast.Error(err.message)
      })

  }


    verifyOTP(formData) {
    this.submitted = true;
    // 
    if (this.otpForm.invalid) {
      return
    }
    let apiUrl = this.apiConfig.verifyOtp;
    let body = { "mobile": this.userData.mobile_no, "user_id": this.userData.user_id, "otp": formData.otp, "program_id": 1 } ;
    window.localStorage.setItem('program', JSON.stringify({ program_id: this.userData.program_id }));

    this.apiService.post(apiUrl, body)
      .subscribe((res: any) => {
        console.log("otp login", res)
        if (res.status == 200) {
          this.errorMessage = true;
          let body = res.body;
          this.toast.Success('Login successful');
          localStorage.setItem("user_name", (res.body.data.user_name));
          localStorage.setItem("user_id", (res.body.data.id));
          window.localStorage.setItem("program", JSON.stringify(res.body.data));
          this.auth.saveAuth(body.data.access_token);
          this.submitted = false;
          if (body.data.user_role >= 12 && body.data.user_role <= 16) {
          // if (body.data.user_role == 14 || body.data.user_role == 16) { //RH and CH
            this.router.navigate(["agent"]);
          }
          else {
            console.log('noaccess')
            this.toast.Success('You dont have access to this module');
          }
        }
      }, err => {
        this.errorMessage = false;
        // 
      })
  }


  smLogin(formData, type) {
    console.log("formData", formData);
    this.submitted = true;
    // 
    if (this.smloginForm.invalid) {
      console.log("asdwdfds");
      return
      
    }
    let apiUrl = this.apiConfig.sendOtpLogin;
    let body = { "email_id": formData.email_id, "program_id": 1 } ;
    window.localStorage.setItem('program', JSON.stringify({ program_id: 1 }));

    this.apiService.post(apiUrl, body)
      .subscribe((res: any) => {
        console.log("response login", res);
        if (res.status == 200) {
          this.errorMessage = true;
          this.userData = res.body.data;
          console.log(this.userData,'userdata')
          this.toast.Success('Otp Sent successful');
          // localStorage.setItem("user_name", (res.body.data.user_name));
         
          this.submitted = false;
          
        }
      }, err => {
        this.errorMessage = false;
        // 
      })
  }

  toggleShowPassword() {
    this.inputPasswordType == 'password' ? this.inputPasswordType = 'text' : this.inputPasswordType = 'password'
    setTimeout(() => { this.inputPasswordType = 'password' }, 1000)
  }

  programSetup(formData) {
    this.passwordSubmitted = true;
    if (this.setupForm.invalid) {
      return
    }
    if (formData.password == 123456) {
      this.router.navigateByUrl('create-new-program')
    } else {
      this.errorMessage = false
    }
    // this.apiService.get(this.apiConfig.setupProgram + formData.password)
    //   .subscribe((res: any) => {
    //     this.toast.Success('Project setup successfully completed');
    //     this.getPrograms();
    //   }, err => {
    //     // this.toast.Error(err.message)
    //   })

  }

  login(formData) {
    //debugger
    this.submitted = true;
    // 
    if (this.loginForm.invalid) {
      return
    }
    let apiUrl = this.apiConfig.login;
    let body = JSON.stringify({ "LoginForm": { "username": formData.username, "password": formData.password, "program_id": formData.program_id } });
    window.localStorage.setItem('program', JSON.stringify({ program_id: formData.program_id }));

    this.apiService.post(apiUrl, body)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.errorMessage = true;
          let body = res.body;
          this.toast.Success('Login successful');
          localStorage.setItem("user_name", (res.body.data.user_name));
          localStorage.setItem("user_id", (res.body.data.id));
          window.localStorage.setItem("program", JSON.stringify(res.body.data));
          this.auth.saveAuth(body.data.access_token);
          this.submitted = false;
          if (body.data.user_role == 1 || body.data.role_name == 'Organization' || body.data.profile_code == 'GNRL') {
            this.router.navigate(["/hubAdmin/dashboard"]);
            this.callProgramConfigApi();
          }
          else if (body.data.role_name == 'Staff') {
            this.router.navigate(["teamleader"]);
          }
          else if (body.data.role_name == 'Agent') {
            this.router.navigate(["agent"]);
          } else if (body.data.role_name == 'Redemption') {
            this.router.navigate(["redemption"]);
          } else if (body.data.role_name == 'Reporting') {
            this.router.navigate(["reports"]);
          } else if (body.data.user_role == 9) {
            localStorage.setItem('reward_role',body.data.user_role)
            this.router.navigate(['/operationalhead/sucess-order-list']);
            // this.router.navigate(['operationalhead']);
          } else if (body.data.user_role == 10) {
            localStorage.setItem('reward_role',body.data.user_role)
            this.router.navigate(['/operationalhead/failed-order-loss']);
            // this.router.navigate(['operationalhead']);
          }
           else if (body.data.user_role == 11) {
            // console.log(body.data.role_name,'role_name');
            this.router.navigate(["concierge"]);
          }
           else if (body.data.role_name == 'Finance') {
           this.router.navigate(["finance"]);
          } else if (body.data.role_name == 'Authorization') {
             this.router.navigate(["authorization"]);
          }
          else {
            this.toast.Success('You dont have access to this module');
          }
        }
      }, err => {
        this.errorMessage = false;
        // 
      })
  }
  isValid(field): boolean {
    let isValid: boolean = false;

    // If the field is not touched and invalid, it is considered as initial loaded form. Thus set as true
    if (this.loginForm.controls[field].touched == false) {
      isValid = true;
    }
    // If the field is touched and valid value, then it is considered as valid.
    else if (this.loginForm.controls[field].touched == true && this.loginForm.controls[field].valid == true) {
      isValid = true;
    }
    return isValid;
  }


  toggleView() {
    this.hideClearDB = !this.hideClearDB
  }

  modalRef
  ClearDbSubmit(value, target) {
    this.clearDBsubmit = true;
    if (this.ClearDbForm.invalid) {

      return
    }
    this.modalRef = this.modalService.open(target, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
      windowClass: ""
    });
    this.modalRef.result.then((result) => {
      if (result) {

      }
    });

  }

  clearDB(value) {
    // return

    let sendData = {
      pwd: value.password,
      program_id: value.program_id
    }
    // return
    this.apiService.get(this.apiConfig.clearDataBase + '?pwd=' + value.password)
      .subscribe((res: any) => {
        this.toggleView()
        this.modalRef.dismiss()
        this.toast.Success('Database cleared successfully')
        this.getPrograms();
      }, err => {

      })
  }


  callProgramConfigApi() {
    let apiUrl = this.apiConfig.programConfig;
    this.apiService.get(apiUrl).subscribe((res: any) => {
      if (res.status == 200) {
        //
        localStorage.setItem("has_beat", (res.data.has_beat));
        localStorage.setItem("has_channel", (res.data.has_channel));
        this.apiService.$beatResonseData.emit(res.data.has_beat);
        this.apiService.$channelResonseData.emit(res.data.has_channel);
      }
    }, (err) => {

    })
  }
}


